export default {
  tab: {
    allExchanges: 'All Exchanges',
    hose: 'HOSE',
    hnx: 'HNX',
    upcom: 'UPCOM',
  },
  typeTab: {
    marketCap: 'MARKET CAP',
    volume: 'VOLUME',
    value: 'VALUE',
    buyVol: 'FR. BUY VOL.',
    sellVol: 'FR. SELL VOL.',
    bulVal: 'FR.BUY VAL.',
    sellVal: 'FR.SELL VAL.',
  },
  noData: 'No data available.',
  ticker: 'TICKER',
  price: 'PRICE',
  percentChange: '% CHANGE',
  marketCap: 'MARKET CAP (BN.)',
  volume: 'VOLUME',
  value: 'VALUE',
  frBuyVol: 'FR.BUY VOL.',
  frSellVol: 'FR.SELL VOL.',
  frBuyVal: 'FR.BUY VAL.',
  frSellVal: 'FR.SELL VAL.',
};
